import { theme } from '@nobia/zeus-components/lib/styled'

export default {
  body: {
    bgColor: '#fff',
    color: '#000',
    padding: '16px',
    tabletWidth: '680px',
    desktopWidth: '1024px',
    marginTablet: '0',
    marginDesktop: '80px',
  },
  header: {
    maxWidth: '700px',
    margin: '30px 0 0 70px',
  },
  section: {
    bgColor: '#ddd',
    color: '#000',
  },
  iconWrapper: {
    bgColor: theme('section.bgColor'),
  },
  card: {
    border: {
      selected: '#000',
      default: '#fff',
    },
  },
  banner: {
    color: '#fff',
    bgColor: '#000',
  },
  email: {
    error: {
      color: 'red',
    },
    bgColor: '#fff',
    input: {
      bgColor:  theme('colors.white'),
      border: '1px solid #bbb',
    },
    minHeight: '40px'
  },
  font: {
    baseFontSize: 14,
    headings: {
      title: {
        wrap: 'nowrap',
        margin: '10px 0 40px'
      },
    },
  },
  colors: {
    darkBlue: '#001c33',
    lighterBlue: '#dfe6f6',
    lightBlue: '#5f7ed2',
    lightBlueTransparent: '#5f7ed244',
  },
  navigation: {
    color: theme('colors.primary'),
    activeColor: theme('colors.primary'),
    activeBackgroundColor: theme('colors.lightBlueTransparent'),
  },
  tabs: {
    background: '#dfe6f6',
    color: theme('colors.primary'),
    backgroundColor: '#e9edf9',
    activeColor: theme('colors.primary'),
    activeBackgroundColor: theme('colors.white'),
  },
  typography: {
    paragraph: {
      color: '#001c33',
      fontWeight: 300,
    },
    link: {
      color: '#5f7ed2',
      fontWeight: 500,
    },
  },
  input: {
    select: {
      bgColor: theme('email.bgColor'),
    },
    borderColor: '#bbb',
  }
}
